import { render, staticRenderFns } from "./videoBox.vue?vue&type=template&id=212be696&scoped=true&"
import script from "./videoBox.vue?vue&type=script&lang=js&"
export * from "./videoBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212be696",
  null
  
)

export default component.exports